import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const IconSections = ({ sectionClassName, sections }) => (
    <div className={`section icons ${sectionClassName}`}>
        {sections.map(({ name, icons }, index) => (
            <Fragment key={generateReactKey(index)}>
                <h3 className="section-name">{name}</h3>
                {icons.map(({ iconClassName, iconText, firstTitle, secondTitle }, iconIdx) => (
                    <div className="wrap" key={generateReactKey(iconIdx)}>
                        <div className={iconClassName || 'square'}>{iconText}</div>
                        {!isEmpty(firstTitle) && (
                            <div className="description">
                                {firstTitle}
                                {!isEmpty(secondTitle) && (
                                    <>
                                        <br /> {secondTitle}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </Fragment>
        ))}
    </div>
);

IconSections.defaultProps = {
    sectionClassName: '',
    sections: [],
};

IconSections.propTypes = {
    sectionClassName: PropTypes.string,
    sections: PropTypes.array,
};

export default IconSections;
